Namespace 'Monitoring.Views.Dashboards'

class Monitoring.Views.Dashboards.TagsHierarchyKeepconModalView extends Backbone.View

  initialize: ({currentTags, translator, firstLevelNodes, includeAlternativeTaxonomies}) ->
    @tagsHierarchyView = new Monitoring.Views.Dashboards.TagsHierarchyView({
      currentTags, translator, firstLevelNodes, includeAlternativeTaxonomies
    })
    @listenTo @tagsHierarchyView, 'selected:tags', (selectedTags) => @trigger('selected:tags', selectedTags)
    @listenTo @tagsHierarchyView, 'modal:close', @closeModal
    @searchBoxView = new Monitoring.Views.Dashboards.TagsHierarchySearchBoxView()
    @listenTo @searchBoxView, 'search-box:search', @search
    @keepconModalView = new Common.Modals.ModalView
      title: I18n.t('monitoring.dashboard.social_content.tag_editor.hierarchy.title')
      contentView: @tagsHierarchyView
      size:
        width: 900
        height: 425

  render: ->
    @tagsHierarchyView.render()
    @keepconModalView.render()
    @keepconModalView.$('.modal-title').after @searchBoxView.render().el
    @

  showModal: ->
    @keepconModalView.openModal()

  closeModal: =>
    @keepconModalView.closeModal()

  search: ({value}) =>
    @tagsHierarchyView.searchTree value
